import withResolvers from './utils/withResolvers';
class RicTracker {
    #idleCallbackId;
    #idleDeadline;
    #deferred;
    constructor() {
        this.#deferred = withResolvers();
    }
    get available() {
        return typeof requestIdleCallback !== 'undefined';
    }
    get deadline() {
        return this.#idleDeadline;
    }
    async waitIdleCallback() {
        return this.#deferred.promise;
    }
    start() {
        if (!this.available || this.#idleCallbackId !== undefined) {
            return;
        }
        this.#idleCallbackId = requestIdleCallback((deadline) => {
            this.#idleDeadline = deadline;
            this.#idleCallbackId = undefined;
            this.#deferred.resolve(deadline);
            this.#deferred = withResolvers();
            this.start();
        }, {
            // wait 3 seconds max to call the next idle callback:
            // - if the browser is actually busy for 3 seconds, we can at least call
            //   rarely and probably the `deadline` will have very little time left
            // - previously Chromium had a bug where it wouldn't fire the idle
            //   callback. the timeout just in case some browser has such a problem.
            timeout: 3000,
        });
    }
    stop() {
        if (!this.available) {
            return;
        }
        cancelIdleCallback(this.#idleCallbackId);
        this.#idleCallbackId = undefined;
    }
}
const ricTracker = new RicTracker();
export default ricTracker;
